import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Swal from 'sweetalert2';
import gql from 'graphql-tag';
import moment from 'moment';
import Loader from '../../components/CustomLoader';
import client from '../../utils/apolloClient';
import { getUser } from '../../data-services/queries';
import { groupSubmissionEntries, listByFcp } from './ettcSubmissionApi';
import Waiting from '../../images/wait.png';
import Confirm from '../../images/confirm.png';

const queryString = require('query-string');

/** CMDI/AMMD drill-down: entries for a selected FCP (read-only). */
class ListETTCSubmissionsForFcp extends Component {
    state = {
        loading: true,
        userData: null,
        entries: [],
        fcpSfid: null,
        fcpName: '',
        backPath: '/ettc-cmdi-fcps',
    };

    async componentDidMount() {
        const params = queryString.parse(
            (this.props.location && this.props.location.search) ||
                window.location.search ||
                ''
        );
        const fcpSfid = params.fcpSfid || null;
        const fcpName = params.fcpName || '';
        const backPath = params.back || '/ettc-cmdi-fcps';

        const { data } = await client.query({ query: gql(getUser) });
        const userData = data && data.user;
        this.setState({ userData, fcpSfid, fcpName, backPath });

        if (
            !userData ||
            (userData.role !== 'CMDI' && userData.role !== 'AMMD') ||
            !fcpSfid
        ) {
            this.setState({ loading: false });
            return;
        }

        try {
            const rows = await listByFcp(fcpSfid);
            this.setState({
                entries: groupSubmissionEntries(rows),
                loading: false,
            });
        } catch (err) {
            this.setState({ loading: false });
            Swal.fire({
                icon: 'error',
                title: 'Load failed',
                text: (err && err.message) || 'Could not load FCP submissions.',
            });
        }
    }

    gotoBack = () => {
        this.props.history.push(this.state.backPath);
    };

    openEntry = (entry) => {
        const { fcpSfid, fcpName, backPath } = this.state;
        const first = entry.submissions && entry.submissions[0];
        if (!first) return;
        const returnTo = `/ettc-fcp-submissions?fcpSfid=${encodeURIComponent(
            fcpSfid
        )}&fcpName=${encodeURIComponent(fcpName || '')}&back=${encodeURIComponent(backPath)}`;
        const batch = `&batch=${encodeURIComponent(entry.batchKey)}`;
        this.props.history.push({
            pathname: '/ettc-submission',
            search: `?id=${first.id}${batch}&mode=readonly&back=${encodeURIComponent(returnTo)}`,
        });
    };

    formatDate = (value) => {
        if (!value) return '-';
        return moment(value).isValid() ? moment(value).format('DD-MMM-YYYY') : value;
    };

    render() {
        const { loading, entries, fcpName } = this.state;

        return (
            <div>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton color="inherit" onClick={this.gotoBack}>
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography variant="title" color="inherit">
                            {fcpName ? `${fcpName} — ETTC` : 'FCP ETTC Submissions'}
                        </Typography>
                    </Toolbar>
                </AppBar>

                {loading ? (
                    <Grid container alignItems="center" justify="center" style={{ marginTop: 24 }}>
                        <Loader type="Audio" color="#00BFFF" height="50" width="50" />
                    </Grid>
                ) : (
                    <Paper square>
                        {!entries.length ? (
                            <Typography style={{ padding: 16 }}>
                                No ETTC submissions for this FCP.
                            </Typography>
                        ) : (
                            entries.map((entry) => {
                                const isPending = entry.pending > 0;
                                const statusLabel = isPending ? 'Pending' : 'Approved';
                                return (
                                    <div key={entry.batchKey}>
                                        <List
                                            onClick={() => this.openEntry(entry)}
                                            style={{ cursor: 'pointer', padding: 12 }}
                                        >
                                            <Grid container spacing={8} alignItems="center">
                                                <Grid item xs={7}>
                                                    <Typography variant="body2">
                                                        {entry.submissionName || 'ETTC'}
                                                    </Typography>
                                                    <Typography variant="caption">
                                                        {entry.total} submission
                                                        {entry.total === 1 ? '' : 's'} ·{' '}
                                                        {this.formatDate(entry.submission_date__c)} ·{' '}
                                                        {entry.evaluated_by_name || 'Evaluator TBD'}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Typography
                                                        align="right"
                                                        variant="body1"
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'flex-end',
                                                        }}
                                                    >
                                                        {statusLabel}
                                                        <img
                                                            src={isPending ? Waiting : Confirm}
                                                            alt={statusLabel}
                                                            style={{ width: 30, paddingLeft: 10 }}
                                                        />
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </List>
                                        <Divider />
                                    </div>
                                );
                            })
                        )}
                    </Paper>
                )}
            </div>
        );
    }
}

export default ListETTCSubmissionsForFcp;
